import * as h2Api from '../h2Api'

export const INDUSTRY_LOADED = 'INDUSTRY_LOADED'
export const SELECT_INDUSTRY_COMPARISON_LMI = 'SELECT_INDUSTRY_COMPARISON_LMI'
export const CLEAR_INDUSTRY_SELECTION = 'CLEAR_INDUSTRY_SELECTION'
export const RATE_INDUSTRY = 'RATE_INDUSTRY'
export const SUPPLY_DEMAND = 'SUPPLY_DEMAND'
export const SUPPLY_DEMAND_LOADING = 'SUPPLY_DEMAND_LOADING'
export const TOP_WAGE_DATA_LOADED = 'TOP_WAGE_DATA_LOADED'
export const TOP_EMPLOYMENT_DATA_LOADED = 'TOP_EMPLOYMENT_DATA_LOADED'
export const UPDATE_TOP_QCEW_FILTER = 'UPDATE_TOP_QCEW_FILTER'
export const START_LOADING = 'QCEW_TOP_START_LOADING'
export const STOP_LOADING = 'QCEW_TOP_STOP_LOADING'
export const TOP_DEMAND_DATA_LOADED = 'TOP_DEMAND_DATA_LOADED'

export const rateIndustry = (industry, ratingType) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  return dispatch(
    h2Api.put(`/user/rate/industry/${industry.id}`, {
      rating: ratingType
    })({ type: RATE_INDUSTRY, id: industry.id })
  )
}

export const startLoading = () => dispatch => {
  dispatch({ type: START_LOADING })
}

export const stopLoading = () => dispatch => {
  dispatch({ type: STOP_LOADING })
}

export const loadSupplyDemand = () => (dispatch, getState) => {
  dispatch({ type: 'SUPPLY_DEMAND_LOADING' })

  return dispatch(h2Api.get('/industry/supplydemand')({ type: SUPPLY_DEMAND }))
}

export const loadIndustry = naics => (dispatch, getState) => {
  dispatch({ type: CLEAR_INDUSTRY_SELECTION })

  return dispatch(h2Api.get(`/industry/profile/${naics}`)({ type: INDUSTRY_LOADED }))
}

export const loadTopQcewWage = () => (dispatch, getState) => {
  dispatch(startLoading())
  const filter = getState().industry.choosing.filter

  return dispatch(
    h2Api.post('/industry/top/wages', filter)({ type: TOP_WAGE_DATA_LOADED })
  )
    .then(v => {
      dispatch(stopLoading())

      return v
    })
    .catch(() => dispatch(stopLoading()))
}

export const loadTopQcewEmployment = () => (dispatch, getState) => {
  dispatch(startLoading())
  const filter = getState().industry.choosing.filter

  return dispatch(
    h2Api.post('/industry/top/employment', filter)({ type: TOP_EMPLOYMENT_DATA_LOADED })
  )
    .then(v => {
      dispatch(stopLoading())

      return v
    })
    .catch(() => dispatch(stopLoading()))
}

export const loadInDemand = () => (dispatch, getState) => {
  dispatch(startLoading())
  console.log(getState())
  const filter = getState().industry.choosing.filter

  return dispatch(
    h2Api.post('/industry/top/indemand', filter)({ type: TOP_DEMAND_DATA_LOADED })
  )
    .then(v => {
      dispatch(stopLoading())

      return v
    })
    .catch(() => dispatch(stopLoading()))
}

export const updateFilter = (field, value) => dispatch => {
  return dispatch({ type: UPDATE_TOP_QCEW_FILTER, field, value })
}

export const selectComparisonRegion = (industry, comparisonRegion) => dispatch => {
  //console.log("RATING", occupation, ratingType)
  console.log('HERE --- ', industry)

  return dispatch(
    h2Api.post(`/industry/profile/${industry.id}/lmi/comparison`, {
      region: comparisonRegion
    })({ type: SELECT_INDUSTRY_COMPARISON_LMI })
  )
}
